import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneType',
})
export class PhoneTypePipe implements PipeTransform {
  map = {
    mobile: 'Mobile',
    fixed_line: 'Landline',
  };

  transform(value: string): string {
    return this.map[value];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/phone-type.pipe.ts